/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CommunityCliQ API
 *  ## Authentication
 *
 *   Every request must include an API access token generated in the CommunityCliQ \
 *   application:
 *
 *   ```
 *   Authorization: X-API-TOKEN
 *   ```
 *
 * OpenAPI spec version: V2.X
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { CommandErrorResponse } from "../../model";

import { customInstance } from "../../../lib/SpringAxios";
import type { ErrorType } from "../../../lib/SpringAxios";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") {
      continue;
    }
    Object.defineProperty(result, key, {
      configurable: true,
      enumerable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get the value of a specific boolean flag via its flag key.
 * @summary Get the value of a specific boolean flag via its flag key.
 */
export const getBooleanFlagState = (
  flagName: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<boolean>(
    { method: "GET", signal, url: `/api/v2/flags/boolean-flags/${flagName}` },
    options,
  );
};

export const getGetBooleanFlagStateQueryKey = (flagName: string) => {
  return [`/api/v2/flags/boolean-flags/${flagName}`] as const;
};

export const getGetBooleanFlagStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getBooleanFlagState>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  flagName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBooleanFlagState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBooleanFlagStateQueryKey(flagName);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBooleanFlagState>>
  > = ({ signal }) => getBooleanFlagState(flagName, requestOptions, signal);

  return {
    enabled: flagName !== null && flagName !== undefined,
    queryFn,
    queryKey,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBooleanFlagState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBooleanFlagStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBooleanFlagState>>
>;
export type GetBooleanFlagStateQueryError = ErrorType<CommandErrorResponse>;

export function useGetBooleanFlagState<
  TData = Awaited<ReturnType<typeof getBooleanFlagState>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  flagName: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBooleanFlagState>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBooleanFlagState>>,
          TError,
          Awaited<ReturnType<typeof getBooleanFlagState>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBooleanFlagState<
  TData = Awaited<ReturnType<typeof getBooleanFlagState>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  flagName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBooleanFlagState>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBooleanFlagState>>,
          TError,
          Awaited<ReturnType<typeof getBooleanFlagState>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBooleanFlagState<
  TData = Awaited<ReturnType<typeof getBooleanFlagState>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  flagName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBooleanFlagState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the value of a specific boolean flag via its flag key.
 */

export function useGetBooleanFlagState<
  TData = Awaited<ReturnType<typeof getBooleanFlagState>>,
  TError = ErrorType<CommandErrorResponse>,
>(
  flagName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBooleanFlagState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBooleanFlagStateQueryOptions(flagName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
